/**
 * Постраничная навигация списков (`component.pagination`, centrika-docs!43; issue #14 —
 * распространение на остальные списки кабинета). Здесь — только счёт: сам элемент
 * управления живёт в `design-system/components/data/pagination`.
 *
 * Размер страницы единый для всех списков — 20 записей, как на эталонной странице
 * `/team/orders`. Серверный потолок одной выдачи — 100 (`parsePage`), поэтому грузить
 * список «целиком» нельзя: страница обязана запрашиваться срезом limit/offset.
 */
export const PAGE_SIZE = 20

/** Срез запроса для страницы (нумерация с 1). */
export function pageQuery(page: number): { limit: number; offset: number } {
  return { limit: PAGE_SIZE, offset: (Math.max(1, page) - 1) * PAGE_SIZE }
}

/**
 * Количество страниц по общему числу записей. Минимум 1: пустой список — это одна
 * (пустая) страница, а не ноль; сам компонент при одной странице не отображается.
 */
export function pageCount(total: number): number {
  if (!Number.isFinite(total) || total <= 0) return 1
  return Math.max(1, Math.ceil(total / PAGE_SIZE))
}
